export class StudentPoolContactPersonModel implements IStudentPoolContactPersonModel {
  contactPersonId?: string | undefined;

  constructor(data?: IStudentPoolContactPersonModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.contactPersonId = Data["contactPersonId"];
    }
  }

  static fromJS(data: any): StudentPoolContactPersonModel {
    data = typeof data === 'object' ? data : {};
    let result = new StudentPoolContactPersonModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["contactPersonId"] = this.contactPersonId;
    return data;
  }
}

export interface IStudentPoolContactPersonModel {
  contactPersonId?: string | undefined;
}
